import { Panel } from '../ui/Panel';
import { ContentEditor } from '../ui/ContentEditor';
import { useSettings } from './useSettings';

/** Instellingen › Cadeaus & codes › Codes: klantcodes voor attributie en de klanten die hun routine delen. */
export function CodeSettings() {
  const {
    json
  } = useSettings();
  return <>
      <Panel title="Klantcodes" description="Voor attributie en een cadeau. Een code geeft nooit korting." data-id="element-3993" data-mp="3c91i13xtpvmn">
        <ContentEditor {...json('codes')} fieldKey="codes" data-id="element-3994" data-mp="3v2nm6qi2ib9" />
      </Panel>
      <Panel title="Klanten die hun routine delen" description="Op de homepage bij “Wat zij dagelijks gebruiken”. Elke klant krijgt een eigen code." data-id="element-3995" data-mp="7w4n8oobwwdr">
        <ContentEditor {...json('creators')} fieldKey="creators" data-id="element-3996" data-mp="3q9c8w6z4va7t" />
      </Panel>
    </>;
}